import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@material-ui/styles';
// import './theme/Themes';

// import ReactDOM from 'react-dom';
import Dashboard from './components/Dashboard';
import SignIn from './components/page/landingpage/SignIn';
import SignUp from './components/page/landingpage/SignUp';

// themes
import { themes } from './theme/Themes';

// user adatok
import UserContext from "./context/UserContext";

// GET - POST 
import useAxios from "./request/useAxios";

function App() {
  const [user, setUser] = useState({});
  const [userTheme, setUserTheme] = useState('default');
  // const [user, setUser] = useState({});
  // const [userTheme, setUserTheme] = useState("narancs");
  const [login, setLogin] = useState(false);
  const [signup, setSignup] = useState(false);
  const [alert, setAlert] = useState(false);

  const { get } = useAxios();

  // user.setUser = setUser;
  // user.setUserTheme = setUserTheme;
  // user.theme = userTheme;

  // user.property = [
  //   { title: "Megbízhatóság", field: "studyIndex", value: 5, checked: true, id: "megbizhatosag" },
  //   { title: "Energiaszint", field: "vocabulary", value: 9, checked: false, id: "energiaszint" },
  //   { title: "Pontosság", field: "readingLiteracy", value: 8, checked: true, id: "pontossag" },
  // ];

  // ha van token a storage-ben akkor be van lépve
  useEffect(() => {
    const TS = JSON.parse(localStorage.getItem("TS"));
    if (TS) setLogin(true);
    window.history.replaceState(null, '', '/');
  }, [])

  useEffect(() => {

    if (login) {
      console.log("load user data");

      // user LOGIN load user data
      const TS = JSON.parse(localStorage.getItem("TS"));
      // get(`/salesman/get-salesman/`,
      get(
        `/salesman/get-salesman/${TS.userId}`,
        {
          headers:
          {
            'Authorization': `Bearer ${TS.token}`
          },
        }
      )
        .then((data) => {
          console.log('user data: ', data)
          // data.user = data;
          let u = {
            user: data,
            settings: {
              setUser: setUser,
              setUserTheme: setUserTheme,
              userTheme: userTheme,
              theme: userTheme,

              property: [
                { title: "Megbízhatóság", field: "studyIndex", value: 5, checked: true, id: "megbizhatosag" },
                { title: "Energiaszint", field: "vocabulary", value: 9, checked: false, id: "energiaszint" },
                { title: "Pontosság", field: "readingLiteracy", value: 8, checked: true, id: "pontossag" },
              ]
            }
          }
          setUser(u);
          // setUser({ ...user, ...data });
          console.log("User: ", user);
        })
        .catch((error) => console.log("Could not load user", error));
    } else {
      // user LOGOUT
      console.log("delete user data");
    }
  }, [login]);

  return (
    <UserContext.Provider value={user}>
      <ThemeProvider theme={themes[userTheme]}>
        {/* {console.log('rend....', user.theme, userTheme)} */}
        {/* <ThemeProvider theme={themes['blue']}> */}
        {login ?
          <Dashboard setLogin={setLogin} /> :
          signup ?
            <SignUp
              useSignup={{ signup, setSignup }}
              useAlert={{ alert, setAlert }}
            /> :
            <SignIn
              useLogin={{ login, setLogin }}
              useSignup={{ signup, setSignup }}
              useAlert={{ alert, setAlert }}
            />
        }
      </ThemeProvider>
    </UserContext.Provider>

  );
}

export default App;
